import { Form, FormikProps } from 'formik';
import * as React from 'react';
import { Panel } from 'react-bootstrap';
import { FieldGroup } from '../misc/FieldGroup';

export interface ICategoryForm {
    id?: number;
    title: string;
}

export const labels = {
    title: 'Title'
};

interface ParentProps {
    controls: (bag: FormikProps<ICategoryForm>) => React.ReactNode;
    editing: boolean;
}

export default (props: ParentProps) => {
    return (bag: FormikProps<ICategoryForm>) => {
        const fieldProps = {
            ...bag,
            labels,
            disabled: !props.editing,
            className: 'col-sm-6'
        };
        return (
            <Form className="form-holder-block">
                <Panel bsStyle="primary" defaultExpanded>
                    <Panel.Heading>
                        <Panel.Title toggle>
                            <h4>Business Category Details</h4>
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body collapsible className="none-indent">
                        <div className="indent-outside">
                            <FieldGroup id="title" {...fieldProps} />
                        </div>
                    </Panel.Body>
                </Panel>
                {props.controls(bag)}
            </Form>
        );
    };
};
